import { Route } from 'react-router-dom';
import type { ReactElement } from 'react';
import { TargetShell } from '../identity/TargetShell';
import { AutomationDashboardPage } from './dashboard/AutomationPage';
import { AgentPage, AgentsPage } from './pages/Agents';
import { RoutesPage } from './pages/Routes';
import { FileWatchersPage } from './pages/FileWatchers';
import { AgentLogsPage } from './pages/AgentLogs';
import { TrafficPage } from './pages/Traffic';
import { TenantsPage } from './pages/Tenants';

/** Path → page; every page runs inside the environment shell (`?target=`, only environments with a gateway). */
const PAGES: [string, () => ReactElement][] = [
  ['/automation/agents', () => <AgentsPage />],
  ['/automation/agents/:id', () => <AgentPage />],
  ['/automation/routes', () => <RoutesPage />],
  ['/automation/file-watchers', () => <FileWatchersPage />],
  ['/automation/logs', () => <AgentLogsPage />],
  ['/automation/traffic', () => <TrafficPage />],
  ['/automation/tenants', () => <TenantsPage />],
];

/** The Automation group's routes: the dashboard when the group may be opened, each page when its nav entry may be. */
export function automationRoutes(canOpenGroup: boolean, allowed: (path: string) => boolean) {
  // An agent's page is open to whoever may open the agent list.
  const nav = (path: string) => (path.startsWith('/automation/agents/') ? '/automation/agents' : path);
  return [
    canOpenGroup && <Route key="/automation" path="/automation" element={<AutomationDashboardPage />} />,
    ...PAGES.filter(([path]) => allowed(nav(path))).map(([path, page]) => (
      <Route key={path} path={path} element={<TargetShell service="automation">{page()}</TargetShell>} />
    )),
  ];
}
